import React, {Component, Fragment, useState}  from 'react';

import {
  //ApiService,
  HaulCheckService,
  //MatchesService,
  //ConversationsService
} from '../../../../services';

export default function UnarchiveMaterial({idsite_resource, idsite, callback}){

    let unarchiveMaterial = async () => {
        await HaulCheckService.unsetArchived(idsite_resource);
        await HaulCheckService.getMatches(idsite);
        callback();
        closePopup();
    }

    let closePopup = () => {
        document.getElementById("close-unarchive-material").click();
    }

    return(<>
        <button id={"open-unarchiveMaterial-site-setting-modal"} data-toggle="popup" data-target={"#unarchive-material"} style={{display: "none"}}>Popup Trigger Button</button>
        <div id="unarchive-material" class="popup col-6 col-md-4 p-0" data-position="top-center" data-animation="slide-down">
            <button type="button" class="close" data-dismiss="popup" aria-label="Close" id="close-unarchive-material">
                <span aria-hidden="true">&times;</span>
            </button>
            <div class="media alert-info p-5">
                <i class="ti ti-book lead pt-3"></i>
                <div class="media-body fw-200">
                    <p class="lead-3 strong ml-2">Recover Material</p>
                    <p class="fw-400 lh-2 mb-4 pr-7">Recover records for this material from the archive.</p>
                    <button type="button" class="btn btn-info float-right mx-2" onClick={unarchiveMaterial}>Recover</button>
                    <button type="button" class="btn btn-outline-info float-right mx-2" onClick={closePopup}>Cancel</button>
                </div>
            </div>
        </div>
    </>)
}